import React, { useContext, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { DevicesContext } from '../contexts/DevicesContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  // if (isLoading) {
  //   return (
  //     <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-gray-100">
  //       <div className="flex flex-col items-center">
  //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"></div>
  //         <p className="text-gray-600">Loading...</p>
  //       </div>
  //     </div>
  //   );
  // }

  const devicesContext = useContext(DevicesContext);
  
  if (!devicesContext) {
    throw new Error('useDevices must be used within a DevicesProvider');
  }
  const { getLiveDataForDashboard } = devicesContext;
  /* Auto-refresh effect - refresh every 5 minutes */
  useEffect(() => {
    const intervel = setInterval(() => {
      console.log("Interval running...");
      getLiveDataForDashboard();
    }, 5 * 60 * 1000);

    return () => {
      clearInterval(intervel);
    }
  }, []);

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Render children if authenticated
  return <>{children}</>;
};

export default ProtectedRoute; 